import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const PixelGravityAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number
) => {
  const count = 60;
  const time = timeSeconds;
  for (let i = 0; i < count; i++) {
    const ang = (i / count) * Math.PI * 2;
    const r = getRadiusAtAngle(ang, e, e.maxRadius);
    const px = Math.cos(ang) * r;
    const py = Math.sin(ang) * r;
    const rx = (Math.random() - 0.5) * 40 * time;
    const ry = 1500 * time * time * (0.6 + Math.random() * 0.8);
    ctx.fillRect(clampX(e.pos.x + px + rx), clampY(e.pos.y + py + ry), 5, 5);
  }
};

registerBlastAnimation('PIXEL_GRAVITY', PixelGravityAnimation);
